import { useState } from 'react'
import { Element } from '../../../../common/html/element'
import { ShortContentCell } from './ShortContentCell'

export const CollapseRow = ({ id, rowIndex }) => {
  const [isHovered, setIsHovered] = useState(false)

  const onMouseEnter = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <Element
      elementName="tr"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: isHovered ? '#ccc' : 'transparent' }}
    >
      <td
        style={{
          color: '#3A414B',
          backgroundColor: isHovered
            ? '#EDF5FE'
            : rowIndex % 2 === 0
            ? '#F9F9F9'
            : '#FFFFFF',
        }}
      />
      <ShortContentCell id={id} isHovered={isHovered} rowIndex={rowIndex} />
    </Element>
  )
}
